import { CarInfo } from "../types/CarInfo";
import { Driver } from "../types/DriverTypes";
import { ReservationResponse } from "../types/ReservationTypes";

export const subDriverIn = () => {
  return {
    type: "IN" as const,
  };
};

export const subDriverInOut = () => {
  return {
    type: "OUT" as const,
  };
};

export const totalPrice = (data: number) => {
  return {
    type: "PRICE",
    payload: data,
  } as const;
};

export const carInfo = (data: CarInfo) => {
  return {
    type: "CARINFO",
    payload: data,
  } as const;
};

export const kioskInfo = (data: any) => {
  return {
    type: "SET_KIOSK",
    payload: data,
  } as const;
};

export const directDriver = (data: boolean) => {
  return {
    type: "DIRECT" as const,
  };
};

export const resInfo = (data: any) => {
  return {
    type: "RESERVATION",
    payload: data.data,
  } as const;
};

export const resOneInfo = (data: ReservationResponse) => {
  return {
    type: "RESERVATION_ONE",
    payload: data,
  } as const;
};

export const product = (data: any) => {
  return {
    type: "PRODUCT",
    payload: data,
  } as const;
};

export const driver = (data: Driver[]) => {
  return {
    type: "DRIVER",
    payload: data,
  } as const;
};

export const file = (array: any) => {
  return {
    type: "FILE",
    payload: array,
  } as const;
};

export const singFile = (array: any) => {
  return {
    type: "SIGN_FILE",
    payload: array,
  } as const;
};

export const driverReset = () => {
  return {
    type: "DRIVER_CLEAR",
  };
};

export const loginUserId = (data: any) => {
  return {
    type: "LOGIN_USER_ID",
    payload: data,
  } as const;
};

export const memberRegFlag = (data: any) => {
  return {
    type: "MEMBER_REG_FLAG",
    payload: data,
  } as const;
};
